import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';
import {Observable} from 'rxjs';
import {ApiConfigService} from './api.config.service';
import {map, tap} from 'rxjs/operators';
import {Municipality} from '../../shared/models/municipality.model';

export type MunicipalityResponse = {
  data: Municipality[];
}

@Injectable({providedIn: 'root'})
export class MunicipalityService {
  private readonly cacheKeyPrefix = 'MunicipalitiesService:GET:';

  constructor(
    private http: HttpClient,
    private cache: HttpCacheService,
    private apiConfigService: ApiConfigService,
  ) {
  }

  invalidateCache(): void {
    this.cache.invalidate(this.cacheKeyPrefix);
  }

  getMunicipalities(province: number): Observable<Municipality[]> {
    const url = this.apiConfigService.getMunicipalitiesUrl(province);
    const key = `${this.cacheKeyPrefix}${url}`;
    return this.cache.getOrSet<MunicipalityResponse>(
      key,
      HTTP_CACHE_TTL_MS.UNIMPORTANT,
      () => this.http.get<MunicipalityResponse>(url)
    ).pipe(
      map((res) => Array.isArray(res.data) ? res.data : []),
      tap(() => console.log('Municipalities fetched successfully'))
    )
  }

}
